/**
 * Store: Multi-store
 * -----------------------------------------------------------------------------
 * User's geolocation.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    geolocation: {
      countryCode: '',
      name: '',
      the: false,
    },
    localization: {
      countries: [],
      languages: [],
    },
    messaging: null,
    state: 'choices',
    storeChosen: '',
    storeChosenHandle: '',
    stores: [],
  }),

  getters: {

    /**
     * Get current store based on localization values.
     * @returns {Object}
     */
    getCurrentStore(state) {
      const url = cnvs.store.shopUrl.replaceAll('/', '').trim()
      const storeUrl = cnvs.store.language === 'en'
        ? url
        : `${url}/${cnvs.store.language}`

      const urlMatchedStores = state.stores.filter((store) => {
        return store.url === storeUrl
      })

      const subStoreMatch = urlMatchedStores.find((store) => {
        return state.storeChosenHandle === store.handle
      })

      const matchedStore = subStoreMatch || urlMatchedStores[0]

      if (matchedStore) {
        return matchedStore
      }

      return state.stores.find((store) => store.name === cnvs.store.name)
    },

    /**
     * Get current store based on localization values.
     * @returns {Object}
     */
    getChosenDetails(state) {
      return {
        store: state.storeChosen,
        handle: state.storeChosenHandle,
      }
    },

    /**
     * Gets the messaging block applied to the customers geolocation country.
     * @returns {Object}
     */
    getRelevantMessaging(state) {
      const country = cnvs?.store?.country

      if (!country) {
        return state.messaging?.fallback
      }

      // eslint-disable-next-line array-callback-return
      const messagingBlock = state.messaging?.blocks.find(block => {
        if (block.countries.includes(country)) {
          return block
        }
      })

      return messagingBlock ? messagingBlock : state.messaging?.fallback
    },
  },

  mutations: {

    /**
     * Set geolocation.
     * @param {Object} geolocation - Formatted geolocation.
     * @param {String} geolocation.countryCode - Country ISO code.
     * @param {String} geolocation.name - Country name.
     */
    SET_GEOLOCATION(state, geolocation) {
      state.geolocation = geolocation
    },

    /**
     * Set localization.
     * @param {Object} localization - Shopify localization.
     */
    SET_LOCALIZATION(state, localization) {
      state.localization = localization
    },

    /**
     * Set multi-store modal state.
     * @param {Array} modalState - Multi-store modal state.
     */
    SET_STATE(state, modalState) {
      state.state = modalState
    },

    /**
     * Set store chosen.
     * - Used to not show modal again after making a choice.
     * @param {String} countryCode - Country code of user's location.
     */
    SET_STORE_CHOSEN(state, countryCode) {
      state.storeChosen = countryCode
    },

    /**
     * Stores user's selected country handle.
     * @param {String} storeHandle - Selected store's handle.
     */
    SET_STORE_CHOSEN_HANDLE(state, storeHandle) {
      state.storeChosenHandle = storeHandle
    },

    /**
     * Set stores.
     * @param {Array} stores - Stores section settings.
     */
    SET_STORES(state, stores) {
      state.stores = stores
    },

    /**
     * Set stores.
     * @param {Array} stores - Stores section settings.
     */
    SET_MESSAGING(state, messaging) {
      state.messaging = messaging
    },
  },

  actions: {

    /**
     * Set geolocation.
     * @param {Object} response - Response from Shopify geolocation app.
     */
    setGeolocation({ commit }, response) {
      const { the } = response
      const { name, handle: countryCode } = response.detected_values.country
      commit('SET_GEOLOCATION', { countryCode, name, the })
    },

    /**
     * Set geolocation messaging.
     * @param {Object} blocks - Geo messaging block data.
     */
    setMessaging({ commit }, blocks) {
      commit('SET_MESSAGING', blocks)
    },

    /**
     * Set localization.
     * @param {Object} localization - Shopify localization.
     */
    setLocalization({ commit }, localization) {
      commit('SET_LOCALIZATION', localization)
    },

    /**
     * Set multi-store modal state.
     * @param {Array} modalState - Multi-store modal state.
     */
    setState({ commit }, modalState) {
      console.log('setState', modalState)
      commit('SET_STATE', modalState)
    },

    /**
     * Set store chosen.
     * - Used to not show modal again after making a choice.
     * @param {String} countryCode - Country code of user's location.
     */
    setStoreChosen({ commit }, countryCode) {
      commit('SET_STORE_CHOSEN', countryCode)
    },

    /**
     * Set store chosen handle.
     * @param {String} storeHandle - Selected store's handle.
     */
    setStoreChosenHandle({ commit }, storeHandle) {
      commit('SET_STORE_CHOSEN_HANDLE', storeHandle)
    },

    /**
     * Set stores.
     * @param {Array} stores - Stores section settings.
     */
    setStores({ commit }, stores) {
      commit('SET_STORES', stores)
    },
  },
}
